import { EnumEnvs } from '@library/store/config/config.interface';

declare global {
  interface Window {
      env: {
        envDomain: string
      }
  }
}
export const environment = {
  project: 'settings-velux',
  authUrl: "https://auth.velux-active.com",
  apiUrl: "https://app.netatmo.net/api/",
  langsUrl: "/langs/",
  syncApiUrl: "https://app.netatmo.net/syncapi/v1/",
  cookiePrefix: "veluxactivecom",
  env: EnumEnvs.PRODUCTION,
  production: true
};
